import {Injectable} from "@angular/core";
import {CanActivate, Router} from "@angular/router";
import {AuthApiService} from "./auth-api.service";

@Injectable()
export class AuthGuardService implements CanActivate {

    constructor(private router: Router,
                private authService: AuthApiService) {
    }

    canActivate() {
        if (this.authService.loginStatus()) {
            return true;
        }
        this.router.navigate(["/login"]);
        return false;
    }
}
